function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['data_quality']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':5000')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
setupInterceptors(appApisGTW);
var headers = {
  'Content-Type': 'application/json'
};
var CONTROLLER_NAME = '/data_quality';
var DOMAIN_PROFILING = '/profiling';
export default {
  createProfilingRule: function createProfilingRule() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/rule"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  editProfilingRule: function editProfilingRule() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.put("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/rule"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getProfilingHistory: function getProfilingHistory() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var email = login['email'];
    var params = _objectSpread({
      email: email
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.get("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/history"), {
      params: params,
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  getDataProfilingHistory: function getDataProfilingHistory() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/history"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  getProfilingExecutions: function getProfilingExecutions() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var email = login['email'];
    var params = _objectSpread({
      email: email
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.get("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/executions"), {
      params: params,
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  updateExecution: function updateExecution() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.put("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/execution"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getReferenceRule: function getReferenceRule() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/reference_rule"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getDashBoardParams: function getDashBoardParams() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILING, "/dashboard/params"), body, {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  }
};